export enum HTTP_RESPONSE {
  SUCCESS = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  UNPROCESSABLE_ENTITY = 422,
  ERROR = -1,
  COMPLETE = 1,
}
